import { computed, inject, Injectable, signal } from '@angular/core';
import {
  AcsMyProjectDataModel,
  CustomList
} from '../../model/acs-project.model';
import { LanguageStore } from '../language.store';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferenceStateService {
  private data: CustomList = {
    expatriation_countries: {
      en: [],
      fr: []
    },
    nationality_countries: {
      en: [],
      fr: []
    },
    minimum_subscription_period: undefined,
    acs_cfe_allowed_nationalities: {
      en: [],
      fr: []
    },
    business_sectors: {
      en: [],
      fr: []
    },
    deductible: undefined
  };

  private languageStore: LanguageStore = inject(LanguageStore);
  private dataState = signal<CustomList>(this.data);

  public updateData(newValue: CustomList) {
    // Met à jour à la fois l'état interne et le signal réactif
    this.data = newValue;
    this.dataState.set(newValue);
  }

  public selectExpatriationCountries() {
    return computed(() =>
      this.languageStore.currentLanguageCode() === 'fr'
        ? this.dataState().expatriation_countries!.fr
        : this.dataState().expatriation_countries!.en
    );
  }

  public selectNationalityCountries() {
    return computed(() =>
      this.languageStore.currentLanguageCode() === 'fr'
        ? this.dataState().nationality_countries!.fr
        : this.dataState().nationality_countries!.en
    );
  }

  public selectBusinessSector() {
    return computed(() =>
      this.languageStore.currentLanguageCode() === 'fr'
        ? this.dataState().business_sectors!.fr
        : this.dataState().business_sectors!.en
    );
  }

  public selectMinimumSubscriptionPeriod() {
    return computed(() => this.dataState().minimum_subscription_period!);
  }

  public selectAcsProjectDataModel(): Observable<AcsMyProjectDataModel> {
    // Renvoie toujours la dernière version des données de référence
    const currentData = this.dataState();
    return of({
      minimum_subscription_period: currentData.minimum_subscription_period,
      nationality_countries: currentData.nationality_countries,
      expatriation_countries: currentData.expatriation_countries,
      acs_cfe_allowed_nationalities: currentData.acs_cfe_allowed_nationalities
    });
  }
}
